import { mockApiImpl } from "./impl";

export const admin = {
  adminLogin: mockApiImpl.adminLogin,
  adminGetMe: mockApiImpl.adminGetMe,
  adminLogout: mockApiImpl.adminLogout,
  adminGetStats: mockApiImpl.adminGetStats,
  adminGetDonationsSummary: mockApiImpl.adminGetDonationsSummary,
  adminGetMonthlyTrend: mockApiImpl.adminGetMonthlyTrend,
  adminGetDonationSources: mockApiImpl.adminGetDonationSources,
  adminGetDonationCategories: mockApiImpl.adminGetDonationCategories,
  adminListDonations: mockApiImpl.adminListDonations,
  adminExportDonationsCsv: mockApiImpl.adminExportDonationsCsv,
  adminListDonationsPaginated: mockApiImpl.adminListDonationsPaginated,
  adminGetDonation: mockApiImpl.adminGetDonation,
  adminListContact: mockApiImpl.adminListContact,
  adminListNewsletter: mockApiImpl.adminListNewsletter,
  adminUpdateNewsletter: mockApiImpl.adminUpdateNewsletter,
  adminGetSettings: mockApiImpl.adminGetSettings,
  adminUpdateSettings: mockApiImpl.adminUpdateSettings,
  adminResetReceiptSequence: mockApiImpl.adminResetReceiptSequence,
  adminListUsers: mockApiImpl.adminListUsers,
  adminCreateUser: mockApiImpl.adminCreateUser,
  adminUpdateUser: mockApiImpl.adminUpdateUser,
  adminDeleteUser: mockApiImpl.adminDeleteUser,
  adminRegenerateReceipt: mockApiImpl.adminRegenerateReceipt,
  adminRegenerateCertificate: mockApiImpl.adminRegenerateCertificate,
  adminResendEmail: mockApiImpl.adminResendEmail,
  adminListAuditLog: mockApiImpl.adminListAuditLog,
  adminUpdateContact: mockApiImpl.adminUpdateContact,
  adminReconcileDonation: mockApiImpl.adminReconcileDonation,
  adminGetDonationGatewayStatus: mockApiImpl.adminGetDonationGatewayStatus,
  adminMarkPaidFromGateway: mockApiImpl.adminMarkPaidFromGateway,
  adminSendPaymentFollowup: mockApiImpl.adminSendPaymentFollowup,
  adminGetFinanceQueueSummary: mockApiImpl.adminGetFinanceQueueSummary,
  adminListDonors: mockApiImpl.adminListDonors,
  adminGetDonor: mockApiImpl.adminGetDonor,
};
